module.exports = __webpack_public_path__ + "8fd55e460911aea8b41fa8776b991502.MP3";